import { ReceiverAddress } from "@duosoftbg/nacid-components";

export const receiverAddressInitialValues: ReceiverAddress = {
  name: "",
  country: { id: "", name: "" },
  settlement: { id: "", name: "", fullSettlementName: "" },
  city: "",
  address: "",
  phone: "",
  postCode: "",
};
